import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

export default function BrandLogoCarousel() {    
    const brandLogos = [
        {
            name: "Miele",
            url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-panasonic-logo.png",
            alt: "Miele logo shown in white lettering on a red background, representing Miele’s premium kitchen appliances including ovens, cooktops, dishwashers, refrigeration, coffee machines, and rangehoods."
        },
        {
            name: "Bosch",
            url: "https://hncnzwww.blob.core.windows.net/www/img/brands/bosch-logo-red.webp",
            alt: "Bosch logo featuring the circular Bosch emblem alongside bold red text on a white background, representing Bosch’s innovative kitchen appliances including dishwashers, ovens, cooktops, and refrigeration products"
        }, 
        {
            name: "F&P",
            url: "https://hncnzwww.blob.core.windows.net/www/img/brands/fisher-and-paykel-white-logo-on-black.webp",
            alt: "Fisher & Paykel logo displayed in white text on a black background, representing Fisher & Paykel’s premium kitchen appliances including refrigeration, cooking, dishwashing, and laundry solutions"
        },
        {
            name: "Westinghouse",
            url: "https://hncnzwww.blob.core.windows.net/www/img/brands/westinghouse-black-logo.webp",
            alt: "Westinghouse logo featuring the brand’s circular crown symbol alongside a black wordmark on a white background, representing Westinghouse’s kitchen appliances including ovens, cooktops, rangehoods, refrigerators, and dishwashers."
        },
        {
            name: "SMEG",
            url: "https://hncnzwww.blob.core.windows.net/www/img/brands/smeg-black-logo.webp",
            alt: "Smeg logo displayed in bold black lettering with the brand’s distinctive circular icon design, representing Smeg’s premium kitchen appliances including ovens, cooktops, refrigerators, dishwashers, and small appliances"
        },
        {
    name: "Gaggenau",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/gaggenau-black-logo.webp",
    alt: "Gaggenau logo shown in bold black typography on a white background, representing Gaggenau's luxury kitchen appliances including ovens, cooktops, rangehoods, coffee machines, and refrigeration products."
},
{
    name: "AEG",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/aeg-red-logo.webp",
    alt: "AEG logo displayed in bold red lettering on a white background, representing AEG's premium kitchen appliances including ovens, cooktops, rangehoods, dishwashers, and refrigeration solutions."
},
{
    name: "NEFF",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/neff-red-logo.webp",
    alt: "NEFF logo displayed in red lettering with the tagline 'cook. create. inspire.' on a white background, representing NEFF's premium kitchen appliances including ovens, cooktops, rangehoods, dishwashers, and built-in cooking solutions."
},
{
    name: "Panasonic",
    url: "https://hncnzwww.blob.core.windows.net/www/img/sector/design-architecture-panasonic-logo.png",
    alt: "Panasonic logo shown in bold black typography on a white background, representing Panasonic's kitchen appliances including microwaves, refrigeration, cooking appliances, and small kitchen solutions."
},
{
    name: "Robinhood",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/robinhood-logo.webp",
    alt: "Robinhood logo featuring a green butterfly icon and grey wordmark on a white background, representing Robinhood's kitchen appliances including rangehoods, cooktops, ovens, sinks, and laundry solutions."
},
{
    name: "EuroCave",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/eurocave-black-logo.webp",
    alt: "EuroCave logo displayed in elegant black typography with a decorative grape-inspired emblem, representing EuroCave's premium wine cabinets, wine storage, and wine preservation solutions for modern kitchens and entertaining spaces."
},
{
    name: "Liebherr",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/liebherr-black-logo.webp",
    alt: "Liebherr logo displayed in bold black typography on a white background, representing Liebherr's premium refrigeration, freezers, wine cabinets, and integrated kitchen cooling solutions."
},
{
    name: "Falcon",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/falcon-logo.webp",
    alt: "Falcon logo displayed on a metallic silver badge with embossed lettering, representing Falcon's premium range cookers, ovens, and cooking appliances for modern and traditional kitchens."
},
{
    name: "Sirius",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/sirius-red-logo.webp",
    alt: "Sirius logo featuring a grey emblem and red wordmark on a white background, representing Sirius's premium rangehoods, ventilation products, and kitchen appliance solutions."
},
{
    name: "Schweigen",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/schweigen-logo.webp",
    alt: "Schweigen logo displayed in white lowercase lettering on a magenta background, representing Schweigen's premium silent rangehoods, ventilation systems, and kitchen extraction solutions."
},
{
    name: "Vintec",
    url: "https://hncnzwww.blob.core.windows.net/www/img/brands/vintec-logo.webp",
    alt: "Vintec logo displayed in bold black lettering with a red triangular accent on a white background, representing Vintec's premium wine cabinets, beverage coolers, and wine storage solutions for modern kitchens and entertaining spaces."
}
        
        
        
    ];
    // Embla autoplay plugin instance
    const autoplay = Autoplay({ delay: 2000, stopOnInteraction: false });

    return (
        <div className="w-full py-16 relative overflow-hidden bg-white">          
            <div className="max-w-12xl mx-auto px-4 ">
                {/* <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-center text-gray-900 mb-10 md:mb-16 lg:mb-24">Our Trusted Brands</h2> */}
                <Carousel
                    opts={{ align: "start", loop: true, slidesToScroll: 1 }}
                    plugins={[autoplay]}
                >
                    <CarouselContent>
                        {brandLogos.map((logo, idx) => (
                            <CarouselItem
                                key={idx}
                                className="flex flex-col items-center justify-center px-6 basis-1/2 md:basis-1/3 lg:basis-1/5"
                            >
                                <img
                                    src={logo.url}
                                    alt={logo.alt}
                                    className="h-7 w-auto md:h-10 lg:h-12 object-contain transition duration-300   m-0"
                                    loading="lazy"
                                />
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious />
                    <CarouselNext />
                </Carousel>
            </div>
        </div>
    );
}